import { CigaretteSkeleton } from './CigaretteSkeleton';

export default CigaretteSkeleton;
